import { registerComponent, debounce, asyncRequest, loading } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-options",
  class ProductOptions extends WYATTElement {
    ELEMENTS_TO_REPLACE = [
      "product-media",
      "product-prices",
      "add-to-cart",
      "inventory-messaging",
      "sku-display",
      "product-options",
    ];

    constructor() {
      super();

      this.form = this.querySelector("form");
      this.options = Array.from(this.querySelectorAll("[data-product-option]"));
      [this.productPath, this.productParams] = this.config.url.split("?");
      this.isPDP = window.location.pathname === this.productPath;

      const debouncedHandler = debounce(
        this.handleOptionChange.bind(this),
        300,
      );

      this.form.addEventListener("change", debouncedHandler.bind(this));
    }

    get formData() {
      return new FormData(this.form);
    }

    get optionNames() {
      const names = Array.from(this.options).map(({ name }) => name);
      return [...new Set(names)];
    }

    get selectedOptionValues() {
      return this.optionNames.map((name) => this.formData.get(name));
    }

    get url() {
      const search = new URLSearchParams(this.productParams);
      search.set("option_values", this.selectedOptionValues.join(","));

      if (this.config.view) {
        search.set("view", this.config.view);
      }

      return `${window.location.origin}${
        this.productPath
      }?${search.toString()}`;
    }

    handleOptionChange(event) {
      const { target } = event;
      const { productUrl } = target.dataset;

      loading.add(this);

      this.updateProductDOM(productUrl);
    }

    async updateProductDOM(productUrl) {
      const url = productUrl || this.url;
      const response = await asyncRequest(url);

      if (response) {
        this.handleSuccessfulUpdate(response, productUrl);
      } else {
        this.handleUnsuccessfulUpdate(productUrl);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(html, productUrl) {
      const url = productUrl || this.url;

      if (productUrl) {
        document.documentElement.innerHTML = html;
      } else {
        const tempContainer = document.createElement("div");
        tempContainer.innerHTML = html;

        tempContainer.querySelectorAll("[form]").forEach((element) => {
          element.setAttribute("form", this.config.addToCardFormID);
        });

        this.publish(
          WYATT.PubSub.events.updateDOM,
          this.ELEMENTS_TO_REPLACE.map((selector) => ({
            liveRegion: `${selector}-${this.config.product.id}`,
            html: tempContainer.innerHTML,
          })),
        );
      }

      if (this.isPDP) {
        window.history.replaceState(null, "", url);
      }
    }

    handleUnsuccessfulUpdate(productUrl) {
      if (this.isPDP) {
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          window.location.href = this.url;
        }
      }
    }
  },
);
